<template>
  <main class="p-sendcompletely">
    <section class="p-sendcompletely__wrap">
      <h2 class="c-regist__title">{{ t('SendMailCompletePage.completeSendMail') }}</h2>
      <RegisterFlow :steps="6" :nowStep="3" />
      <p class="c-regist__comment">
        {{ t('SendMailCompletePage.sendMsg') }}
      </p>
      <p class="p-sendcompletely__caution">{{ t('SendMailCompletePage.inCompleteRegisterMsg') }}</p>
      <ul class="p-sendcompletely__notes">
        <li class="p-sendcompletely__note">
          {{ t('SendMailCompletePage.infoMsg1') }}
        </li>
        <li class="p-sendcompletely__note">
          {{ t('SendMailCompletePage.infoMsg2') }}
          <br />
          {{ t('SendMailCompletePage.infoMsg3') }}
        </li>
      </ul>
      <div
        class="p-sendcompletely__link"
        :class="{ isDisabled: !state.isEnabledResend }"
        @click="onClickConfirmationCorrection"
      >
        <a class="c-button">
          <span class="c-button__text">{{ t('SendMailCompletePage.modifyMailAddress') }}</span>
        </a>
      </div>
    </section>
  </main>
</template>

<script lang="ts">
import { defineComponent, reactive, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import RegisterFlow from '@/components/registerTeam/RegisterFlow.vue'
import useValidateForAccess from '@/Hooks/useValidateForAccess'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'SendMailCompletelyPage',
  setup() {
    const state = reactive({
      isEnabledResend: true,
      isVisibleConfirm: false,
      dialogSetting: {
        title: '',
        message: '',
      },
    })
    const router = useRouter()
    const { t, locale } = useI18n()
    onMounted(() => {
      useValidateForAccess(
        'RegisterTeamStore',
        ['teamName', 'organizationType', 'mailAddress'],
        'ErrorPage',
      )
    })
    return {
      state,
      t,
      locale,
      /**
       * メールアドレス確認・修正ボタン押下時
       */
      onClickConfirmationCorrection() {
        router.replace({ name: 'AuthenticateUserPage' })
      },
    }
  },
  components: {
    RegisterFlow,
  },
})
</script>

<style scoped lang="scss">
.isDisabled {
  opacity: 0.3;
  pointer-events: none;
}
</style>
